import http from './http.service';

class ClientService {
    constructor() {
        if (ClientService.instance) {
            return ClientService.instance;
        }

        ClientService.instance = this;
    }

    clients() {
        return http.get('/client').then(res => res.data);
    }
    store(data) {
        return http.post('/client/store', data).then(res => res.data);
    }
    show(clientId) {
        return http.get(`/client/${clientId}/show`).then(res => res.data);
    }
    update(clientId, data) {
        return http.put(`/client/${clientId}/update`, data).then(res => res.data);
    }
    destroy(clientId) {
        return http.delete(`/client/${clientId}/destroy`).then(res => res.data);
    }
}

export default new ClientService();
